import { SxProps, Theme } from '@mui/material/styles';

export const customIconWrapperSx: SxProps<Theme> = {
  display: 'flex',
};

export const technologyIconWrapperSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
};

export const exactMatchIconSx: SxProps<Theme> = {
  color: 'text.secondary',
  verticalAlign: 'middle',
};

// MUI's default tooltip max-width of 300px drops the last word of the longer
// labels onto a second line. Widened on this tooltip only, rather than through
// a `MuiTooltip` theme override, because tooltips elsewhere — `ExactMatchToggle`
// and the Market Depth column headers — carry longer copy that should wrap.
//
// Bounded rather than `none`: the field label is caller-supplied, so an
// unexpectedly long label should wrap instead of running off-screen. 360px
// holds the longest label in use today, `Counterparties must match this
// Settlement Point Index.` (54 characters at the tooltip's 0.6875rem with
// 4px 8px padding), on one line with roughly eight characters of headroom.
export const exactMatchTooltipSx: SxProps<Theme> = { maxWidth: 360 };
